import classNames from 'classnames';

import gutterStyles from '../../grid-gutter.module.css';
import type { Position } from '../../PageConfigProvider/types/item';
import styles from '../EditableGrid.module.css';
import { useGrid } from '../GridProvider';
import type { GhostPlaceholder } from '../utils/ghost-layout-generator';

interface GhostPlaceholdersProps {
  ghosts: GhostPlaceholder[];
  onAddItem: (position: Position) => void;
  onContextMenu?: (position: Position, event: React.MouseEvent) => void;
  onMouseEnter?: (position: Position) => void;
  onMouseLeave?: (position: Position) => void;
}

export const GhostPlaceholders = ({
  ghosts,
  onAddItem,
  onContextMenu,
  onMouseEnter,
  onMouseLeave,
}: GhostPlaceholdersProps) => {
  const { gridItems, edgeDragging } = useGrid();

  return (
    <>
      {ghosts.map((ghost, i: number) => (
        <div
          key={ghost.id}
          style={{
            gridColumn: `${ghost.position.x + 1} / span ${ghost.position.width}`,
            gridRow: `${ghost.position.y + 1} / span ${ghost.position.height}`,
          }}
          className={classNames(
            styles.addGhost,
            styles.ghostCenter,
            gutterStyles.cell,
            {
              [styles.edgeDragging ?? '']: edgeDragging,
              [styles.firstGhost ?? '']: i === 0 && gridItems.length === 0,
            }
          )}
          onClick={() => onAddItem(ghost.position)}
          onContextMenu={(event) => onContextMenu?.(ghost.position, event)}
          onMouseEnter={() => onMouseEnter?.(ghost.position)}
          onMouseLeave={() => onMouseLeave?.(ghost.position)}
        >
          + Create Chart
        </div>
      ))}
    </>
  );
};
